import { DcfRequest, Visit, Session, QueryOfVisit, QueryOfSession, QueryOfSubject } from "WebPortalClient";
import {
    DataCorrectionRequestFormFields,
} from "./DataCorrectionRequestForm";
import { Correction, MiscCorrection, VisibleWizard } from './DcfRequestReducer';
import { CorrectionTypesEnum } from "../../misc/api/apiTypes";

export enum DcfRequestActionType {
    AddRecord = "AddRecord",
    RemoveRecord = "RemoveRecord",
    FailedToSave = "FailedToSave",
    SaveSuccess = "SaveSucess",
    SelectSiteOption = "SelectSiteOption",
    LoadSubjectsOptions = "LoadSubjectsOptions",
    LoadVisitsOptions = "LoadVisitsOptions",
    LoadSessionOptions = "LoadSessionOptions",
    SelectSubjectOption = "SelectSubjectOption",
    SelectVisitOption = "SelectVisitOption",
    LoadingSubjectOptions = "LoadingSubjectOptions",
    LoadingVisitOptions = "LoadingVisitOptions",
    LoadingSessionOptions = "LoadingSessionOptions",
    ShowAuditModal = "ShowAuditModal",
    Submitting = "Submitting",
    LoadingSessionTypeOptions = "LoadingSessionTypeOptions",
    SelectSessionOption = "SelectSessionOption",
    AddCorrection = "AddCorrection",
    AddMiscCorrection = "AddMiscCorrection",
    SetVisibleWizard = "SetVisibleWizard",
    ResetForm = "ResetForm",
    ResetError = "ResetError",
    HydrateForm = "HydrateForm",
    SetCorrectionType = "SetCorrectionType",
}

declare const rootUrl: string;

export type DcfRequestAction =
    | AddRecordAction
    | RemoveRecordAction
    | SaveSuccessAction
    | FailedToSaveAction
    | LoadingSubjectOptionsAction
    | LoadSubjectsOptionsAction
    | LoadVisitOptionsAction
    | LoadingVisitOptionsAction
    | LoadSessionOptionsAction
    | LoadingSessionOptionsAction
    | SubmittingAction
    | ShowAuditModalAction
    | SelectSubjectOptionAction
    | SelectVisitOptionAction
    | SelectSessionOptionAction
    | AddCorrectionAction
    | AddMiscCorrectionAction
    | SetVisibleWizardAction
    | ResetFormAction
    | ResetErrorAction
    | HydrateFormAction
    | SelectSiteOptionAction
    | SetCorrectionTypeAction;

export class AddRecordAction {
    type: DcfRequestActionType.AddRecord;

    static create(): AddRecordAction {
        return {
            type: DcfRequestActionType.AddRecord
        };
    }
}

export class RemoveRecordAction {
    type: DcfRequestActionType.RemoveRecord;
    id: string;

    static create(id: string): RemoveRecordAction {
        return {
            type: DcfRequestActionType.RemoveRecord,
            id: id
        };
    }
}

export class SubmittingAction {
    type: DcfRequestActionType.Submitting;
    isSubmitting: boolean;

    static create(isSubmitting: boolean): SubmittingAction {
        return {
            type: DcfRequestActionType.Submitting,
            isSubmitting: isSubmitting
        };
    }
}

export class SaveSuccessAction {
    type: DcfRequestActionType.SaveSuccess;
    requestIds: Array<DcfRequest>;

    static create(requestIds: Array<DcfRequest>): SaveSuccessAction {
        return {
            type: DcfRequestActionType.SaveSuccess,
            requestIds: requestIds
        };
    }
}

export class FailedToSaveAction {
    type: DcfRequestActionType.FailedToSave;
    message: string;

    static create(message: string): FailedToSaveAction {
        return {
            type: DcfRequestActionType.FailedToSave,
            message: message,
        };
    }
}

export class SelectSiteOptionAction {
    type: DcfRequestActionType.SelectSiteOption;
    siteId: string;
    formApi: any;

    static create(siteId: string, formApi: any): SelectSiteOptionAction {
        return {
            type: DcfRequestActionType.SelectSiteOption,
            siteId: siteId,
            formApi
        };
    }
}

export class SelectSubjectOptionAction {
    type: DcfRequestActionType.SelectSubjectOption;
    recordId: string;
    subjectId: string;
    correctionRecordIndex: number;

    static create(
        recordId: string,
        subjectId: string,
        correctionRecordIndex: number,
    ): SelectSubjectOptionAction {
        return {
            type: DcfRequestActionType.SelectSubjectOption,
            recordId: recordId,
            subjectId: subjectId,
            correctionRecordIndex
        };
    }
}

export class SelectVisitOptionAction {
    type: DcfRequestActionType.SelectVisitOption;
    recordId: string;
    visit: Visit;
    correctionRecordIndex: number;

    static create(
        recordId: string,
        visit: Visit,
        correctionRecordIndex: number,
    ): SelectVisitOptionAction {
        return {
            type: DcfRequestActionType.SelectVisitOption,
            recordId: recordId,
            visit: visit,
            correctionRecordIndex
        };
    }
}

export class LoadSubjectsOptionsAction {
    type: DcfRequestActionType.LoadSubjectsOptions;
    query: QueryOfSubject;

    static create(response: QueryOfSubject): LoadSubjectsOptionsAction {
        return {
            type: DcfRequestActionType.LoadSubjectsOptions,
            query: response
        };
    }
}

export class LoadingSubjectOptionsAction {
    type: DcfRequestActionType.LoadingSubjectOptions;

    static create(): LoadingSubjectOptionsAction {
        return {
            type: DcfRequestActionType.LoadingSubjectOptions
        };
    }
}

export class LoadingVisitOptionsAction {
    type: DcfRequestActionType.LoadingVisitOptions;
    recordId: string;

    static create(recordId: string): LoadingVisitOptionsAction {
        return {
            type: DcfRequestActionType.LoadingVisitOptions,
            recordId: recordId
        };
    }
}

export class LoadVisitOptionsAction {
    type: DcfRequestActionType.LoadVisitsOptions;
    visits: QueryOfVisit;
    recordId: string;

    static create(recordId: string, visits: QueryOfVisit): LoadVisitOptionsAction {
        return {
            type: DcfRequestActionType.LoadVisitsOptions,
            visits: visits,
            recordId: recordId
        };
    }
}

export class LoadingSessionOptionsAction {
    type: DcfRequestActionType.LoadingSessionOptions;
    recordId: string;

    static create(recordId: string): LoadingSessionOptionsAction {
        return {
            type: DcfRequestActionType.LoadingSessionOptions,
            recordId: recordId
        };
    }
}

export class LoadSessionOptionsAction {
    type: DcfRequestActionType.LoadSessionOptions;
    query: QueryOfSession;
    recordId: string;

    static create(recordId: string, response: QueryOfSession): LoadSessionOptionsAction {
        return {
            type: DcfRequestActionType.LoadSessionOptions,
            recordId: recordId,
            query: response
        };
    }
}

export class ShowAuditModalAction {
    type: DcfRequestActionType.ShowAuditModal;
    show: boolean;

    static create(show: boolean = true): ShowAuditModalAction {
        return {
            type: DcfRequestActionType.ShowAuditModal,
            show: show
        };
    }
}

export class SelectSessionOptionAction {
    type: DcfRequestActionType.SelectSessionOption;
    recordId: string;
    session: Session;
    formApi: any;
    correctionRecordIndex: number;

    static create(
        recordId: string,
        session: Session,
        correctionRecordIndex: number,
        formApi: any
    ): SelectSessionOptionAction {
        return {
            type: DcfRequestActionType.SelectSessionOption,
            recordId: recordId,
            session: session,
            formApi,
            correctionRecordIndex
        };
    }
}

export class AddCorrectionAction {
    type: DcfRequestActionType.AddCorrection;
    correction: Correction;

    static create(correction: Correction): AddCorrectionAction {
        return {
            type: DcfRequestActionType.AddCorrection,
            correction: correction,
        };
    }
}

export class SetCorrectionTypeAction {
    type: DcfRequestActionType.SetCorrectionType;
    correctionType: CorrectionTypesEnum;

    static create(correctionType: CorrectionTypesEnum): SetCorrectionTypeAction {
        return {
            type: DcfRequestActionType.SetCorrectionType,
            correctionType: correctionType,
        };
    }
}

export class AddMiscCorrectionAction {
    type: DcfRequestActionType.AddMiscCorrection;
    correction: MiscCorrection;

    static create(correction: MiscCorrection): AddMiscCorrectionAction {
        return {
            type: DcfRequestActionType.AddMiscCorrection,
            correction: correction,
        };
    }
}

export class SetVisibleWizardAction {
    type: DcfRequestActionType.SetVisibleWizard;
    recordId: string;
    wizard: VisibleWizard;
    fieldValue: any;

    static create(recordId: string, wizard: VisibleWizard, fieldValue: any): SetVisibleWizardAction {
        return {
            type: DcfRequestActionType.SetVisibleWizard,
            recordId: recordId,
            wizard: wizard,
            fieldValue: fieldValue
        };
    }
}

export class ResetFormAction {
    type: DcfRequestActionType.ResetForm;

    static create(): ResetFormAction {
        return {
            type: DcfRequestActionType.ResetForm,
        };
    }
}

export class ResetErrorAction {
    type: DcfRequestActionType.ResetError;

    static create(): ResetErrorAction {
        return {
            type: DcfRequestActionType.ResetError,
        };
    }
}

export class HydrateFormAction {
    type: DcfRequestActionType.HydrateForm;
    form: DataCorrectionRequestFormFields;

    static create(form: DataCorrectionRequestFormFields): HydrateFormAction {
        return {
            type: DcfRequestActionType.HydrateForm,
            form: form,
        };
    }
}
